<div class="row" *ngIf="device">
  <div class="col-lg-12">
    <div class="grid">
      <p class="grid-header">Edit Device</p>
      <div class="grid-body">
        <div class="item-wrapper">
          <form (ngSubmit)="submitForm()" #deviceForm="ngForm">
            <div class="form-group">
              <label for="name">Name</label>
              <input [(ngModel)]="device.name" #name="ngModel" name="name" type="text" class="form-control" [ngClass]="{'is-invalid': name.invalid && (name.dirty || name.touched)}" required/>
              <div *ngIf="name.invalid && (name.dirty || name.touched)" class="invalid-feedback">
                <p *ngIf="name.errors?.required">
                  Device Name is required.
                </p>
              </div>
            </div>
            <div class="form-group">
              <label for="code">Serial #</label>
              <input [(ngModel)]="device.code" name="code" type="text" class="form-control" #code="ngModel" [ngClass]="{'is-invalid': code.invalid && (code.dirty || code.touched)}" required/>
              <div *ngIf="code.invalid && (code.dirty || code.touched)" class="invalid-feedback">
                <p *ngIf="code.errors?.required">
                  Serial is required.
                </p>
              </div>
            </div>
            <div class="form-group">
              <label for="org_id">Organization</label>
              <select [(ngModel)]="device.org_id" class="form-control ng-pristine ng-valid ng-touched" name="org_id" #org_id="ngModel" [ngClass]="{'is-invalid': org_id.invalid && (org_id.dirty || org_id.touched)}" required>
                <option *ngFor="let subOrg of organizationService.subOrgs" [value]="subOrg.id">
                  {{subOrg.name}}
                </option>
              </select>
              <div *ngIf="org_id.invalid && (org_id.dirty || org_id.touched)" class="invalid-feedback">
                <p *ngIf="org_id.errors?.required">
                  Organization is required.
                </p>
              </div>
            </div>
            <div class="form-group">
              <label for="location_id">Location</label>
							<select [(ngModel)]="device.location_id" class="form-control ng-pristine ng-valid ng-touched" name="location_id" #location_id="ngModel" [ngClass]="{'is-invalid': location_id.invalid && (location_id.dirty || location_id.touched)}" required>
                <option *ngFor="let location of locationService.locations | locationOrgFilter:device.org_id" [value]="location.id">
                  {{location.company}}
                </option>
              </select>
              <div *ngIf="location_id.invalid && (location_id.dirty || location_id.touched)" class="invalid-feedback">
                <p *ngIf="location_id.errors?.required">
                  Location is required.
                </p>
              </div>
            </div>
            <div class="form-group">
              <label for="vpn_port">VPN Port</label>
              <input [(ngModel)]="device.vpn_port" name="vpn_port" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="vpn_ip">VPN IP Address</label>
              <input [(ngModel)]="device.vpn_ip" #vpn_ip="ngModel" name="vpn_ip" type="text" class="form-control" [ngClass]="{'is-invalid': vpn_ip.invalid && (vpn_ip.dirty || vpn_ip.touched)}" pattern="\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b"/>
              <div *ngIf="vpn_ip.invalid && (vpn_ip.dirty || vpn_ip.touched)" class="invalid-feedback">
                <p *ngIf="vpn_ip.errors?.pattern">
                  Must be a valid IP address.
                </p>
              </div>
            </div>
            <div class="form-group">
              <label for="subnet_mask">Netmask</label>
              <input [(ngModel)]="device.subnet_mask" #subnet_mask="ngModel" name="subnet_mask" type="text" class="form-control" [ngClass]="{'is-invalid': subnet_mask.invalid && (subnet_mask.dirty || subnet_mask.touched)}" pattern="^(((255\.){3}(255|254|252|248|240|224|192|128|0+))|((255\.){2}(255|254|252|248|240|224|192|128|0+)\.0)|((255\.)(255|254|252|248|240|224|192|128|0+)(\.0+){2})|((255|254|252|248|240|224|192|128|0+)(\.0+){3}))$" />
              <div *ngIf="subnet_mask.invalid && (subnet_mask.dirty || subnet_mask.touched)" class="invalid-feedback">
                <p *ngIf="subnet_mask.errors?.pattern">
                  Must be a valid Subnet Mask.
                </p>
              </div>
            </div>
            <div class="form-group">
              <label for="hologram_device_id">Hologram Link ID</label>
              <input [(ngModel)]="device.hologram_device_id" #hologram_device_id="ngModel" name="hologram_device_id" type="text" class="form-control" />
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-sm btn-primary" [disabled]="!deviceForm.form.valid">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
